// src/pages/Users/Inscription/dossier/utils/dossierInscription.utils.js

const API_URL = String(
  process.env.REACT_APP_API_URL || "",
).replace(/\/+$/, "");

export function toAbsoluteUrl(value) {
  if (!value) return "";

  const url = String(value).trim();

  if (!url) return "";

  if (
    /^https?:\/\//i.test(url) ||
    url.startsWith("data:") ||
    url.startsWith("blob:")
  ) {
    return url;
  }

  if (url.startsWith("//")) {
    return `https:${url}`;
  }

  if (url.startsWith("/uploads/")) {
    return API_URL
      ? `${API_URL}${url}`
      : url;
  }

  if (url.startsWith("uploads/")) {
    return API_URL
      ? `${API_URL}/${url}`
      : `/${url}`;
  }

  return url;
}

export function getDefaultAvatar(genre) {
  return genre === "Féminin"
    ? "/img/judokate_avatar.png"
    : "/img/judoka_avatar.png";
}

export function toBooleanFlag(value) {
  if (typeof value === "boolean") return value;

  if (typeof value === "number") {
    return value !== 0;
  }

  if (typeof value === "string") {
    return [
      "1",
      "true",
      "yes",
      "oui",
      "validé",
      "valide",
    ].includes(
      value.trim().toLowerCase(),
    );
  }

  return Boolean(value);
}

export function formatDate(value) {
  if (!value) return "—";

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return "—";
  }

  return date.toLocaleDateString(
    "fr-FR",
  );
}

export function normalizeText(value) {
  return String(value || "")
    .normalize("NFD")
    .replace(
      /[\u0300-\u036f]/g,
      "",
    )
    .toLowerCase()
    .trim();
}

export function getAdherentStatusTheme(
  status,
) {
  const themes = {
    Licencié: {
      badge:
        "bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-500/10 dark:text-emerald-300 dark:border-emerald-500/20",
      border:
        "border-l-emerald-500",
    },

    "Licencié Hors Club": {
      badge:
        "bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-500/10 dark:text-emerald-300 dark:border-emerald-500/20",
      border:
        "border-l-emerald-400",
    },

    Inscrit: {
      badge:
        "bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-500/10 dark:text-amber-300 dark:border-amber-500/20",
      border:
        "border-l-amber-400",
    },

    "Cours d'essai": {
      badge:
        "bg-blue-50 text-[#013E8E] border-blue-200 dark:bg-blue-500/10 dark:text-blue-300 dark:border-blue-500/20",
      border:
        "border-l-blue-500",
    },

    "Licencié - Arrêt": {
      badge:
        "bg-slate-100 text-slate-600 border-slate-200 dark:bg-slate-800 dark:text-slate-300 dark:border-slate-700",
      border:
        "border-l-slate-400",
    },

    "Ancien Licencié et Arrêt": {
      badge:
        "bg-slate-100 text-slate-600 border-slate-200 dark:bg-slate-800 dark:text-slate-300 dark:border-slate-700",
      border:
        "border-l-slate-400",
    },

    "Ancien Licencié": {
      badge:
        "bg-slate-800 text-white border-slate-800 dark:bg-slate-700 dark:border-slate-600",
      border:
        "border-l-slate-700",
    },

    "Non Licencié - Arrêt": {
      badge:
        "bg-slate-100 text-slate-600 border-slate-200 dark:bg-slate-800 dark:text-slate-300 dark:border-slate-700",
      border:
        "border-l-slate-500",
    },
  };

  return (
    themes[status] || {
      badge:
        "bg-slate-100 text-slate-600 border-slate-200 dark:bg-slate-800 dark:text-slate-300 dark:border-slate-700",

      border:
        "border-l-slate-300",
    }
  );
}

export function getSeasonClasses(
  season,
  activeSeason,
) {
  if (
    season &&
    activeSeason &&
    String(season) ===
      String(activeSeason)
  ) {
    return `
      border border-emerald-200
      bg-emerald-50
      text-emerald-700

      dark:border-emerald-500/20
      dark:bg-emerald-500/10
      dark:text-emerald-300
    `;
  }

  return `
    border border-slate-200
    bg-slate-100
    text-slate-600

    dark:border-slate-700
    dark:bg-slate-800
    dark:text-slate-300
  `;
}

export function getDossierProgress(
  dossier,
) {
  if (!dossier) {
    return {
      done: 0,
      total: 3,
      percent: 0,
    };
  }

  const states = [
    toBooleanFlag(
      dossier.validate_cm,
    ),

    toBooleanFlag(
      dossier.validate_licence,
    ),

    toBooleanFlag(
      dossier.validate_reglement,
    ),
  ];

  const done =
    states.filter(Boolean).length;

  return {
    done,
    total: states.length,

    percent: Math.round(
      (done / states.length) * 100,
    ),
  };
}